import useEntity from "../../hooks/useShipment";
import ShipmentDetail from "../../components/shipment/ShipmentDetail/ShipmentDetail";
import ShipmentScoped from "../../components/shipment/ShipmentDetail/ShipmentScoped";
import ShipmentTabs from "../../components/shipment/ShipmentDetail/ShipmentTabs";
import { useGetShipmentQuery } from "../../apis/Shipment.api";
import { PrimaryShipment } from "../../types/models/Shipment";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import {useGetCuttingQuery} from "../../apis/Cutting.api.ts";
import {PrimaryCutting} from "../../types/models/Cutting.ts";
import {cuttingStateEditCheck, shippingStateCheck} from "../../stateChecks.ts";

const ShipmentDetailPage = () => {

    useTitle(t`Details Shipment`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { shipmentId: id } = useParams();

    const { data, refetch } = useGetShipmentQuery(PrimaryShipment.fromPath(id))
    const { deleteShipment } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteShipment(data, '..')
    }, [data, deleteShipment])

    const { data: cutting } = useGetCuttingQuery(PrimaryCutting.fromId(data?.cuttingId), {skip: !data?.cuttingId})

    const stateAllowed = shippingStateCheck(session, data?.state)

    if (id === 'scoped') {
        return (<ShipmentScoped/>)
    }

    return (
        <Box data-testid="Shipment-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ShipmentDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Shipments/update/view'
        ) ||
false) &&
                        cuttingStateEditCheck(cutting?.state)
                        && stateAllowed &&
                        <Button size="small" variant="outlined" data-testid="Shipment-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Shipments/delete/view'
        ) ||
false) &&
                        cuttingStateEditCheck(cutting?.state)
                        && stateAllowed &&
                        <Button size="small" color="error" variant="outlined" data-testid="Shipment-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ShipmentTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ShipmentDetailPage;
